import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  PUSH_NOTIFICATIONS_DATA,
  PUSH_NOTIFICATION_DATA_BY_ID,
  COUNTIES_DATA,
  SET_PUSH_NOTIFICATIONS_API_PARAMS_OBJ,
  ADD_PUSH_NOTIFICATIONS_LOCAL_DATA,
  UPDATE_PUSH_NOTIFICATIONS_LOCAL_DATA,
  DELETE_PUSH_NOTIFICATIONS_LOCAL_DATA,
} from '../../constants/ActionTypes';
import { updateApiResObject } from '../../util/helper';

const INIT_STATE = {
  error: '',
  pushNotificationsLoading: false,
  apiParamsObj: {},
  pushNotificationsCount: 0,
  pushNotificationsData: [],
  pushNotificationDataById: {},
  countiesData: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return {
        ...state,
        error: '',
        pushNotificationsLoading: true,
      };
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: '',
        pushNotificationsLoading: false,
      };
    }
    case FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        pushNotificationsLoading: false,
      };
    }
    case SET_PUSH_NOTIFICATIONS_API_PARAMS_OBJ: {
      return {
        ...state,
        apiParamsObj: action.payload,
      };
    }
    case PUSH_NOTIFICATIONS_DATA: {
      return {
        ...state,
        error: '',
        pushNotificationsCount: action.payload.totalCount,
        pushNotificationsData: action.payload.data,
        pushNotificationsLoading: false,
      };
    }
    case PUSH_NOTIFICATION_DATA_BY_ID: {
      return {
        ...state,
        error: '',
        pushNotificationDataById: action.payload,
        pushNotificationsLoading: false,
      };
    }
    case COUNTIES_DATA: {
      return {
        ...state,
        error: '',
        countiesData: action.payload,
        pushNotificationsLoading: false,
      };
    }
    case ADD_PUSH_NOTIFICATIONS_LOCAL_DATA: {
      return {
        ...state,
        error: '',
        pushNotificationsCount: state.pushNotificationsCount + action.count,
        pushNotificationsData: action.payload,
        pushNotificationsLoading: false,
      };
    }
    case UPDATE_PUSH_NOTIFICATIONS_LOCAL_DATA: {
      return {
        ...state,
        error: '',
        pushNotificationsData: updateApiResObject(
          state.pushNotificationsData,
          action.payload
        ),
        pushNotificationsLoading: false,
      };
    }
    case DELETE_PUSH_NOTIFICATIONS_LOCAL_DATA: {
      return {
        ...state,
        error: '',
        pushNotificationsCount: state.pushNotificationsCount - 1,
        pushNotificationsData: action.payload,
        pushNotificationsLoading: false,
      };
    }
    default:
      return state;
  }
};
